import { editOnly } from 'routing/constants'
import {
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID,
} from '../constants/siteStatuses'

export function getEditOnlyContext(site) {
  const statusId = site?.SiteStatus?.id
  const editOnlySiteStatus =
    statusId === SITE_STATUS_EDIT_ONLY_ID ||
    statusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  return {
    editOnlySite: editOnlySiteStatus ? editOnly : null,
    editOnlySiteStatus,
  }
}
